import React, { useEffect, useState, useRef, useMemo } from "react";
import ReactTable from "react-table-6";
import _ from "../../compat/lodashplus";
import {
  Form,
  Button,
  Icon,
  Checkbox,
  Segment,
  Dropdown,
  Header,
  Modal,
  Label,
} from "semantic-ui-react";
import { Table } from "react-lib/frameworks/Table";
import MultidisciplinaryEditor from "./MultiDisciplinaryEditor";
import { useFormatDropdown } from "react-lib/utils/hooksUtils";
import { isEmpty } from "lodash";

import CardLayout from "react-lib/apps/common/CardLayout";
import RightLabel from "react-lib/apps/common/RightLabel";
import ErrorMessage from "react-lib/apps/common/ErrorMessage";
import DateTextBox from "react-lib/apps/common/DateTextBox";
import ModInfo from "react-lib/apps/common/ModInfo";
import ModAuthen from "react-lib/apps/common/ModAuthen";
import { useIntl } from "react-intl";
import { adToBe, formatUTCtoBEString } from "react-lib/utils/dateUtils";
import moment from "moment";

interface CardMultiDisciplinaryViewProps {
 controller?: Record<string,any>;
 onGetMultidisciplinary?: () => void;
 onSaveMultidisciplinary?: () => void;
 onDeleteMultidisciplinary?: () => void;
 onPrintMultidisciplinary?: () => void;
 onGetMultidisciplinaryLogs?: () => void;
 encounterId?: number | string;
}

const DEFAULT_PROPS = {
  closeable: true,
  toggleable: true,
  defaultBackground: true,
  hideHeaderIcon: false,
  onGetMultidisciplinary: () => {},
  onSaveMultidisciplinary: () => {},
  onDeleteMultidisciplinary: () => {},
  onPrintMultidisciplinary: () => {},
  multidisciplinaryLoading: false,
  multidisciplinaryData: [],
  django: {},
  actionLogs: [],
  enableMargin: true,
  readOnly: true,
  encounterId: "",
}
const CardMultiDisciplinaryView = (propParam: CardMultiDisciplinaryViewProps) => {
  const props = {
    ...DEFAULT_PROPS,
    ...propParam
  }
  const intl = useIntl();
  const toDate = moment().format("DD/MM/YYYY");

  const [errors, setErrors] = useState<any[]>([]);
  const [isShowModAddMulti, setIsShowModAddMulti] = useState(false);
  const [authmodalOpen, setAuthModalOpen] = useState(false);
  const [deleteItemId, setDeleteItemId] = useState(null);
  const [authErrorsMessage, setAuthErrorsMessage] = useState(null);
  const [deleteLoading, setDeleteLoading] = useState(false);
  const [modifiedData, setModifiedData] = useState<any[]>([]);
  const [startDate, setStartDate] = useState();
  const [endDate, setEndDate] = useState(adToBe(toDate));
  const [searchByDate, setSearchByDate] = useState(true);
  const [printText, setPrintText] = useState(false);
  const [loading, setLoading] = useState({print: false, log: {}});
  // choice
  const [practitionerChoice, setPractitionerChoice] = useState({});
  const [roleType, setRoleType] = useState(0);
  const [checkAll, setCheckAll] = useState(false);
  const [openMobSuccess, setOpenMobSuccess] = useState(false);
  const [openActionLog, setOpenActionLog] = useState<boolean>(false);
  const [logsItems, setLogsItems] = useState<any[]>([]);

  const editorRef = useRef(null);
  const isMounted = useRef(false);

  const ActionLog = (props: any) => {
    const data = useMemo(
      () =>
        (props.data || [])?.map((item: any) => ({
          ...item,
          datetime: formatUTCtoBEString(item.datetime)?.join(" "),
        })),
      [props.data]
    );
    return (
      <div style={{ padding: "10px" }}>
        <Header>
          {`ประวัติ`}
          <Label color="yellow">{props.code}</Label>
        </Header>
        <Table
          data={data}
          headers="Date-time, Edit user, Status"
          keys="datetime,edit_user_name,action"
          minRows="10"
          showPagination={false}
          style={{ height: "300px" }}
        ></Table>
      </div>
    );
  };

  const style = {
    fluid: { width: "100%" },
    chkboxRight: { marginLeft: "auto", marginRight: 0 },
    inline: { margin: "0 0 0.5em 0" },
    blueFont: { color: "#3180ed" },
    grayColor: "#f3f3f3",
    textWrap: { wordWrap: "break-word", whiteSpace: "pre-line" },
  };

  useEffect(() => {
    isMounted.current = true;
    getPractitionerChoice();
    props.onGetMultidisciplinary({});

    return () => {
      isMounted.current = false;
    };
  }, []);

  useEffect(() => {
    props.onGetMultidisciplinary({});
    searchAndFilter();
  }, [props.encounterId]);

  useEffect(() => {
    if (props.multidisciplinaryData !== null) {
      // console.log(" props.multidisciplinaryData", props.multidisciplinaryData)
      var clonedProp = JSON.parse(JSON.stringify(props.multidisciplinaryData || []));
      var tmpData = [];
      for (let item of clonedProp) {
        item.chk = false;
        console.log(item);
        tmpData.push(item);
      }
      if (isMounted.current) {
        console.log(tmpData);
        setModifiedData(tmpData);
      }
    }
  }, [props.multidisciplinaryData]);

  useEffect(() => {
    let checkChk = modifiedData.find((item: any) => item.chk === false);

    if (checkChk === undefined) {
      setCheckAll(true);
    } else {
      setCheckAll(false);
    }
  }, [modifiedData]);

  const searchAndFilter = () => {
    var query = {};
    if (searchByDate) {
      query.nurseRecordStartDate = startDate ? startDate.toString() : "";
      query.nurseRecordEndDate = endDate ? endDate.toString() : "";
    }
    if (props.encounterId) {
      query.encounterId = props.encounterId;
    }
    query.practitionerRole = roleType ? roleType : "";
    console.log("searchAndFilter: " + query);
    props.onGetMultidisciplinary(query);
  };

  const getPractitionerChoice = async () => {
    if (props.controller) {
      const [data, error] = await props.controller.getChoices({
        model: "users.Role",
        field: "type",
        nameAsId: true,
      });
      if (isMounted.current) {
        if (error) {
          setErrors(error);
        }
        data.splice(0, 0, { id: 0, value: "", text: "ทั้งหมด" });
        setPractitionerChoice(data);
      }
    }
  };

  const practitionerChoiceList = useFormatDropdown(
    practitionerChoice ? practitionerChoice : [],
    "text",
    "id"
  );

  const onSaveMultidisciplinary = async (data) => {
    console.log("onSaveMultidisciplinary");
    console.log(props.multidisciplinaryData);
    console.log(data);

    let errors = await props.onSaveMultidisciplinary(data); //เรียกจริง
    if (isEmpty(errors)) {
      console.log("Save success");
      props.onGetMultidisciplinary({});
      setIsShowModAddMulti(false);
      editorRef.current.clearValue();
    } else {
      console.log("Save failed", errors);
    }

    return errors;
  };

  const handleModVerifyUserCancel = () => {
    setDeleteItemId(null);
    setAuthModalOpen(false);
  };

  const handleDeleteVerify = async (data: any) => {
    setDeleteLoading(true);
    setAuthErrorsMessage(null);
    var params = {};
    params.username = data.username;
    params.password = data.password;

    let errors = await props.onDeleteMultidisciplinary(deleteItemId, params);
    if (errors) {
      setDeleteLoading(false);
      console.log(errors);
      setAuthErrorsMessage(errors);
    } else {
      props.onGetMultidisciplinary({}); //refresh
      setAuthModalOpen(false);
      setDeleteLoading(false);
      setDeleteItemId(null);
      setOpenMobSuccess(true);
    }
  };

  const handleCheckboxChange = (checked, data) => {
    data.original.chk = checked;
    setModifiedData(JSON.parse(JSON.stringify(modifiedData)));
  };

  const handleCheckAll = (checked) => {
    setCheckAll(!checkAll);
    for (let item of modifiedData) {
      item.chk = checked;
    }
    setModifiedData(JSON.parse(JSON.stringify(modifiedData)));
  };

  const handlePrintItem = async () => {
    setLoading({print:true, log:{}});
    var params = {
      encounter: props.encounterId,
      pdf: true,
      item_list: [],
    };
    // #var printList = [];
    // for (let item of modifiedData) {
    //   if (item.chk) {
    //     printList.push(item.id);
    //   }
    // }
    const printList = modifiedData.filter((item) => item.chk).map((item) => item.id);
    params.item_list = printList;
    let errors = await props.onPrintMultidisciplinary(params);

    if (errors) {
      // toast.error("พิมพ์ไม่สำเร็จ");
      setLoading({print:false, log:{}});
    } else {
      setLoading({print:false, log:{}});
      setPrintText(true);
      setTimeout(() => {
        setPrintText(false);
      }, 2000);
      // toast.success("พิมพ์สำเร็จ");
    }
  };

  const handleGetLogs = async (item_id: any) => {
    console.log("handleGetLogs", item_id);
    setLoading({print:false, log:{[item_id]:true}});
    var params = {
      item_id: item_id,
    };
    try {
      const responses = await props.onGetMultidisciplinaryLogs(params);
      setLoading({print:false, log:{}});

      if (responses?.length > 0) {
        // Process the responses to format the `changes` field
        const formattedLogs = responses.map((log: any) => ({
          ...log,
          changesDetails: log.changes
            ? Object.entries(log.changes).map(
                ([field, { old, new: newValue }]) => `${field}: "${old}" → "${newValue}"`
              )
            : ["No changes"], // Provide a default value if no changes
        }));

        setLogsItems(formattedLogs);
        setOpenActionLog(true);
      } else {
        setLogsItems([]);
        setOpenActionLog(false);
      }
    } catch (error) {
      setLoading({print:false, log:{}});
      console.error("Error fetching logs:", error);
      // Optionally, show an error toast or message
      // toast.error("Failed to fetch logs");
    }
  };

  useEffect(() => {
    if (!isShowModAddMulti) {
      editorRef.current.clearValue();
    }
  }, [isShowModAddMulti]);

  return (
    <CardLayout
      titleText="Multidisciplinary"
      headerColor="teal"
      closeable={props.closeable}
      toggleable={props.toggleable}
      defaultBackground={props.defaultBackground}
      hideHeaderIcon={props.hideHeaderIcon}
      // loading={props.multidisciplinaryLoading}
      enableMargin={props.enableMargin}
    >
      <Modal
        onClose={() => setOpenActionLog(false)}
        onOpen={() => setOpenActionLog(true)}
        open={openActionLog}
      >
        <ActionLog data={logsItems} code={""} />
      </Modal>
      <Form error={errors ? true : false}>
        <ErrorMessage error={errors} />
        <Form.Group inline>
          <Form.Field width={1}></Form.Field>
          <Form.Field inline width={7}>
            <RightLabel>Practitioner</RightLabel>
            <div style={{ width: "40%", marginRight: "15px" }}>
              <Dropdown
                selection
                fluid
                value={roleType}
                options={practitionerChoiceList}
                onChange={(e, data) => {
                  setRoleType(data.value);
                }}
              ></Dropdown>
            </div>
            <div
              style={{
                display: "flex",
                justifyContent: "flex-end",
              }}
            >
              <Checkbox
                label={intl.formatMessage({ id: "ระบุวันที่" })}
                className={"ui checkbox"}
                checked={searchByDate}
                onChange={(e, value) => {
                  setSearchByDate(value.checked);
                }}
              />
            </div>
          </Form.Field>
          <Form.Field inline width={3}>
            <div style={{ width: "100%" }}>
              <DateTextBox
                value={startDate}
                onChange={(date) => {
                  setStartDate(date);
                }}
              />
            </div>
          </Form.Field>
          <Form.Field inline width={3}>
            <div style={{ width: "100%" }}>
              <DateTextBox
                value={endDate}
                onChange={(date) => {
                  setEndDate(date);
                }}
              />
            </div>
          </Form.Field>
          <Form.Field inline width={2} style={{ display: "flex", justifyContent: "flex-end" }}>
            <Button
              icon
              type="button"
              color="green"
              style={{ width: "100%" }}
              size={"small"}
              onClick={_.debounce(searchAndFilter, 500, { leading: true })}
            >
              <Icon name="search" />
              ค้นหา
            </Button>
          </Form.Field>
        </Form.Group>
      </Form>
      <ReactTable
        style={{ height: 470, backgroundColor: "#ffffff" }}
        // defaultPageSize={modifiedData.length > 8 ? modifiedData.length : 8}
        // showPagination={modifiedData.length >= 25}
        minRows={8}
        showPagination={false}
        data={modifiedData}
        columns={[
          {
            Header: "",
            accessor: "working_shift",
            style: { whiteSpace: "unset", textAlign: "center" },
            width: 60,
            Cell: (data) => {
              return (
                <div style={{ textAlign: "center", width: "100%" }}>
                  <Checkbox
                    // defaultChecked={false}
                    checked={data.original.chk}
                    onChange={(e, value) => {
                      handleCheckboxChange(value.checked, data);
                    }}
                  ></Checkbox>
                </div>
              );
            },
          },
          {
            Header: "Date",
            accessor: "date",
            style: { whiteSpace: "unset" },
            minWidth: 50,
          },
          {
            Header: "Problem",
            accessor: "problem",
            style: { whiteSpace: "unset" },
            minWidth: 100,
            Cell: (data) => {
              return (
                <div>
                  <p style={style.textWrap}>{data.original.problem}</p>
                </div>
              );
            },
          },
          {
            Header: "Plan",
            accessor: "plan",
            style: { whiteSpace: "unset" },
            minWidth: 100,
            Cell: (data) => {
              return (
                <div>
                  <p style={style.textWrap}>{data.original.plan}</p>
                </div>
              );
            },
          },
          {
            Header: "Goal",
            accessor: "goal",
            style: { whiteSpace: "unset" },
            minWidth: 100,
            Cell: (data) => {
              return (
                <div>
                  <p style={style.textWrap}>{data.original.goal}</p>
                </div>
              );
            },
          },
          {
            Header: "Practitioner",
            accessor: "practitioner_name",
            style: { whiteSpace: "unset" },
            minWidth: 50,
          },
          {
            Header: "End Date",
            accessor: "end_date",
            style: { whiteSpace: "unset" },
            minWidth: 50,
          },
          {
            Header: "",
            accessor: "edit",
            width: 120,
            Cell: (data) => {
              return (
                <Form
                  style={{
                    display: props.readOnly ? "none" : "block",
                  }}
                >
                  <Form.Field>
                    <Button
                      icon
                      color="yellow"
                      onClick={() => {
                        console.log(editorRef.current.getValue());
                        setIsShowModAddMulti(true);
                        editorRef.current.setValue(data.original);
                        console.log(data.original);
                      }}
                    >
                      <Icon name="pencil" />
                    </Button>
                    <Button
                      icon
                      color="red"
                      style={{
                        display: props.readOnly ? "none" : "block",
                        ...(props.userId &&
                          props.userId !== data.original.practitioner && {
                            display: "none",
                          }),
                      }}
                      onClick={() => {
                        setDeleteItemId(data.original.id);
                        setAuthModalOpen(true);
                      }}
                    >
                      <Icon name="trash" />
                    </Button>
                    <Button
                      icon
                      color="gray"
                      onClick={() => {
                        console.log(editorRef.current.getValue());
                        handleGetLogs(data.original.id);
                      }}
                      loading={loading.log?.[data.original.id]}
                    >
                      <Icon name="history" />
                    </Button>
                  </Form.Field>
                </Form>
              );
            },
          },
        ]}
      />

      <Form>
        <Form.Group inline style={{ marginTop: "10px" }}>
          <Form.Field className="one wide">
            <Button
              id="cardmultidisciplinary-button-add-1"
              icon
              circular
              color="yellow"
              style={{ display: props.readOnly ? "none" : "absolute" }}
              onClick={() => {
                setIsShowModAddMulti(true);
                editorRef.current.clearValue();
              }}
            >
              <Icon name="add" />
            </Button>
          </Form.Field>
          <Form.Field style={{ flex: 1 }} />
          <Form.Field>
            <Checkbox
              label={intl.formatMessage({ id: "เลือกทั้งหมด" })}
              className={"ui checkbox"}
              checked={checkAll}
              onChange={(e, value) => {
                handleCheckAll(value.checked);
              }}
            />
          </Form.Field>
          <Form.Field className="two wide">
            <Button
              icon
              color="blue"
              style={{ width: "100%" }}
              onClick={_.debounce(handlePrintItem, 500, { leading: true })}
              loading={loading.print}
            >
              {printText ? (
                <Icon className="check" />
              ) : (
                <div>
                  <Icon name="print" />
                  พิมพ์
                </div>
              )}
            </Button>
          </Form.Field>
        </Form.Group>
      </Form>

      <Segment style={{ display: isShowModAddMulti ? "block" : "none" }}>
        <MultidisciplinaryEditor
          ref={editorRef}
          encounterId={props.encounterId}
          django={props.django}
          onSaveMultidisciplinary={onSaveMultidisciplinary}
          onClose={() => {
            console.log("close click");
            setIsShowModAddMulti(false);
          }}
        />
      </Segment>

      <ModAuthen
        open={authmodalOpen}
        titleName={intl.formatMessage({ id: "ระบุ Username และ Password เพื่อลบ" })}
        error={authErrorsMessage}
        approveButtonLoading={deleteLoading}
        onDeny={handleModVerifyUserCancel}
        onCloseWithDimmerClick={handleModVerifyUserCancel}
        onApprove={handleDeleteVerify}
      />

      <ModInfo
        type="success"
        titleName={""}
        titleColor="green"
        closeOnDimmerClick
        open={openMobSuccess}
        onApprove={() => setOpenMobSuccess(false)}
        onClose={() => setOpenMobSuccess(false)}
      />
    </CardLayout>
  );
};

// Do not use React.memo
// because checkbox in the table not re-render
export default React.memo(CardMultiDisciplinaryView);
